import React from "react";
import { CXContext } from "./cxContext";
import * as dc from "dc";
import glamorous from "glamorous";
import { rhythm } from "../../utils/typography";
import { css } from "glamor";

const ResetButton = (props) => {
  const style = css({
    padding: rhythm(0.1),
    display: "inline",
    cursor: "pointer",
    float: "right",
    marginLeft: "0.5rem",
    "&:hover": {
      background: "#ddd",
    },
  });
  return (
    <span
      {...style}
      onClick={() => {
        props.chart.filterAll();
        dc.redrawAll();
      }}
    >
      reset
    </span>
  );
};

export const ChartTemplate = (props) => {
  /*
    We render the dc chart using an effect. We want to pass the chart as a prop after the dc call,
    but there is nothing by default to trigger a re-render and the prop, by default would be undefined.
    To solve this, we hold a state key and increment it after the effect ran. 
    By passing the key to the parent div, we get a rerender once the chart is defined. 
    */
  const context =
    React.useContext(CXContext); /* link the chart template with data store */
  const [chart, updateChart] = React.useState(null); /*  */
  const ndx = context.ndx;
  const somendx = context.somendx; // testing delete
  const geojson = context.boundary;
  const div = React.useRef(null);

  React.useEffect(() => {
    // chartfunction takes the ref and does something with it
    const newChart = props.chartFunction(div.current, ndx, geojson);
    newChart.render();
    updateChart(newChart);
  }, [1]); // Run this exactly once

  const Box = glamorous.div({
    background: "aliceblue",
    width: "auto",
    height: "auto",
    border: "8px" + "outset" + "#999",
    display: "inline",
  });
  const chartStyles = css({
    // background: "aliceblue",
    width: "auto",
    height: "auto",
    boxSizing: "border-box",
    paddingTop: "5px",
    textAlign: "center",
    "& label": {
      // textTransform: "capitalize",
      textAlign: "center",
      fontSize: "0.75rem",
    },
    "& select": {
      width: "8.4rem",
      color: "#118AAA",
      background: " #e8e2e2",
      border: "#e8e2e2",
      //textAlign: "center",
      borderRadius: "4px",
      fontSize: "0.75rem",
      float:"left",
      marginLeft:"1rem"
    },
    "& h6": {
      float: "left",
      fontSize: "0.75rem",
      paddingRight: "0.2rem",
    },
    "& svg": {
      // background: "aliceblue",
      // width: "20rem",
    },

    "dc-leaflet leaflet-container": {
      height: "540px !important",
    },
    "leaflet-top": {
      zIndex: 900,
    },
    "& text": {
        fontSize: "0.65rem",
        fill:"#141212 !important"
    },
  });
  return (
    <div ref={div} {...chartStyles}>
      <span>
        <h6>{props.name}</h6>
      </span>
      {/* <ResetButton chart={chart} /> */}
      <label style={{ textDecoration: "underline" }}>{props.title}</label>
      {/* <br /> */}
    </div>
  );
};
